import EstadoList from '../components/ediarios/garantia/EstadoList';
import GarantiaEstadoMList from '../components/emensuales/garantia/GarantiaEmList';
import CreditoEstadoMList from '../components/emensuales/credito/CreditoEmList';
import isUserHasProfile from './profileValidator';
import { CIERRE_DIARIO_READ, CIERRE_OPERACIONAL_READ } from './profilePermission';

const getUserHome = () => {
  if (isUserHasProfile(CIERRE_DIARIO_READ)) {
    return { path: '/reservas/garantia/estados_diarios', component: EstadoList };
  }

  if (isUserHasProfile(CIERRE_OPERACIONAL_READ)) {
    return { path: '/reservas/garantia/estados_mensuales', component: GarantiaEstadoMList };
  }

  return { path: '/reservas/credito/estados_mensuales', component: CreditoEstadoMList };
};

export default getUserHome;
